<template>
  <div class="pro_detail_page">
    <div class="m">
      <div class="pro_detail">
        <div class="pro_detail_l">
          <div class="pro_info">
            <h3>{{params.name}}</h3>
            <h4 v-if="params.common_category && params.common_category.length">作品编号：{{params.code}}</h4>
            <h4>{{params.school_name}}</h4>
            <div class="pro_info_footer">
              <div class="pro_info_footer_l">{{params.publish_date}}发布</div>
              <div class="pro_info_footer_r">
                <span>
                  <i class="icon_eay"></i>{{params.popularity||0}}
                </span>
                <span>
                  <i class="icon_xin"></i>{{params.like_count||0}}
                </span>
              </div>
            </div>
          </div>
          <div class="pro_detail_text_img">
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane label="作品详情" name="detail">
                <!-- 作品视频 -->
                <div class="video_player" v-if="activeName === 'detail'">
                  <videoPay videoId="player-con1" v-if="params.videoPath" :video="params.videoPath"></videoPay>
                </div>
                <p class="synopsis">{{params.synopsis}}</p>
                <img class="detail_img" v-for="item in params.image_detailsPath" :src="item" alt />
              </el-tab-pane>
              <el-tab-pane  label="创作花絮" name="highlights" v-if="params.is_highlight">
                <!-- 花絮视频 -->
                <div class="video_player" v-if="activeName === 'highlights'">
                  <videoPay videoId="player-con2" v-if="params.highlight_videoPath" :video="params.highlight_videoPath"></videoPay>
                </div>
                <p class="synopsis">{{params.highlight_synopsis}}</p>
                <img class="detail_img" v-for="item in params.highlight_image_detailsPath" :src="item" alt />
              </el-tab-pane>
              <el-tab-pane  label="浏览记录" name="browse">
                <div class="record_box" v-if="record_list.length">
                  <div class="record_item" v-for="(item, index) in record_list" :key="index">
                    <div class="avatar">
                      <img
                          v-lazy="item.headPath ? item.headPath :'https://sctcc-applet.oss-cn-shenzhen.aliyuncs.com/zaizhan/img/default.png'"
                          alt
                      />
                    </div>
                    <div class="record">
                      <p>{{item.content}}</p>
                    </div>
                  </div>
                </div>
                <p class="synopsis" v-else>暂无浏览记录</p>
              </el-tab-pane>
            </el-tabs>

          </div>
          <div class="fun_box">
            <div class="like" v-if="!liked.liked_flag">
              <createLike :opus_info="params" :bigSize="true" :liked="liked" :counts="counts"></createLike>
            </div>
            <div class="link" v-else>
              <cancelLike :opus_info="params" :bigSize="true" :liked="liked" :counts="counts"></cancelLike>
            </div>
            <div class="share" >
              <div @click="showShare" class="share_btn">
                <i class="icon_share"></i>
                <span>分享</span>
              </div>

              <div class="share_dialog" v-if="show_share">
                <div class="share_dialog_l">
                  <p>作品网址</p>

                  <el-input :value="url" style="width:196px;">
                    <template slot="append">
                      <div class="fuzhi" @click="common.copyToClipboard(url)">复制</div>
                    </template>
                  </el-input>
                </div>
                <div class="share_dialog_r">
                  <p>微信扫码分享</p>
                  <div id="qrcode"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 右侧悬浮 -->
        <div class="pro_detail_r">
          <dl>
            <dt>创作人员</dt>
            <dd class="author">
              <div class="author_l">
                <template v-if="params.student && params.student.length">
                  <router-link :to="'/designer/student_detail?id='+params.student+'&user='+params.user_id">
                    <img :src="params.designer_headPath" alt />
                  </router-link>
                </template>
                <template v-else>
                  <router-link :to="'/designer/teacher_detail?user='+params.user_id">
                    <img :src="params.designer_headPath" alt />
                  </router-link>
                </template>
              </div>
              <div class="author_r">
                <div class="author_r_t">
                  <template v-if="params.student && params.student">
                    <router-link :to="'/designer/student_detail?id='+params.student+'&user='+params.user_id">
                      <div class="author_name">{{params.student_name}}</div>
                    </router-link>
                  </template>
                  <template v-else>
                    <router-link :to="'/designer/teacher_detail?user='+params.user_id">
                      <div class="author_name">{{params.designer_name}}</div>
                    </router-link>
                  </template>
                  <follow :params="designer"></follow>
                </div>
                <div class="author_r_b">{{params.school_name}}</div>
              </div>
            </dd>
            <!-- 团队 -->
            <template v-if="team_member_list.length > 0">
              <dd class="author" v-for="item in team_member_list" >
                <div class="author_l">
                  <router-link :to="'/designer/student_detail?id='+item.id+'&user='+item.user">
                    <img :src="item.designer.headPath" alt />
                  </router-link>
                </div>
                <div class="author_r">
                  <div class="author_r_t">
                    <router-link :to="'/designer/student_detail?id='+item.id+'&user='+item.user">
                      <div class="author_name">{{item.name}}</div>
                    </router-link>
                    <follow :params="item.designer"></follow>
                  </div>
                  <div class="author_r_b">{{item.school_name}}</div>
                </div>
              </dd>
            </template>


            <template v-if="teacher.length > 0">
              <dt>指导老师</dt>
              <dd class="author" v-for="item in teacher">
                <div class="author_l">
                  <router-link :to="'/designer/teacher_detail?id='+item.teacher.id+'&user='+item.teacher.user">
                    <img :src="item.teacher.designer.headPath" alt />
                  </router-link>
                </div>
                <div class="author_r">
                  <div class="author_r_t">
                    <router-link :to="'/designer/teacher_detail?id='+item.teacher.id+'&user='+item.teacher.user">
                      <div class="author_name">{{item.teacher.name}}</div>
                      <!-- <div class="author_name">{{item.teacher.designer.nick_name}}</div> -->
                    </router-link>
                    <!--                  <div class="care_btn" v-if="true">关注</div>-->
                    <!--                  <div class="care_btn2" v-else>已关注</div>-->
                    <!--                  <follow :params="item.teacher.designer"></follow>-->
                  </div>
                  <div class="author_r_b">{{item.teacher.school_name}}-{{item.teacher.professional_title_name}}</div>
                </div>
              </dd>
            </template>

          </dl>
        </div>
      </div>
    </div>
    <!-- 底部作者其他作品 -->
    <div class="designer_other_opus">
      <div class="other_opus_inner m">
        <div class="tit">
          <h1>猜您喜欢</h1>
        </div>
        <div class="other_opus">
          <div class="other_opus_box">
            <div
              class="other_opus_content"
              @mouseenter="showBtns(true)"
              @mouseleave="showBtns(false)"
            >
              <div class="opus_box">
                <div
                  class="opus_item"
                  v-for="(item, index) in opus_list"
                  :key="index"
                  @click="toOpusDetail(item.opus)"
                >
                  <img v-lazy="item.opus_coverPath" alt />
                </div>
              </div>
              <div
                class="next"
                @click="next()"
                v-show="click_counts<(opus_list.length-4)"
                :class="{showbtns:btns_flag}"
              >
                <i class="el-icon-arrow-right"></i>
              </div>
              <div class="pre" @click="pre()" v-show="click_counts>0" :class="{showbtns:btns_flag}">
                <i class="el-icon-arrow-left"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import createLike from "@/components/likeOpus/createLike.vue";
import cancelLike from "@/components/likeOpus/cancelLike.vue";
import follow from "@/components/followDesigner/follow.vue"
import videoPay from "@/components/videoPay.vue"
import QRCode from 'qrcodejs2'  // 引入qrcode
export default {
  components: {
    createLike,
    cancelLike,
    follow,
    videoPay
  },
  data() {
    return {
      params:{},
      opus_list: [],
      teacher: [],
      record_list: [],
      opus_info: {}, //作品信息
      designer: {}, //创作人员
      team_member_list: [],
      click_counts: 0, //记录点击按钮次数
      btns_flag: false, //两个按钮显示flag
      show_share: false, //是否显示分享
      url: window.location.href, //分享连接
      activeName: 'detail', //highlights
      liked:{
        liked_flag: false
      },
      counts:{
        liked_counts: 0
      }
    };
  },
  created(){
    this.getData();

  },
  methods: {
    showShare(){
      let url = '';
     if(process.env.NODE_ENV==='production'){
          url = `http://m.zaizhan.cn/#/work_detail?id=${this.$route.query.id}`
      }else{
         url = `http://120.78.79.8:8080/qiantai/h5-project/zaizhan/dist/#/work_detail?id=${this.$route.query.id}`
      }
      console.log(url)
      this.show_share = !this.show_share;
     
      // let url = `http://m.zaizhan.cn/#/work_detail?id=8244e12d07102cf130a49d79d06589d4`
      this.$nextTick(()=>{
        let qrcode = new QRCode('qrcode', {
          width: 132,
          height: 132,
          text: url, // 二维码地址
          colorDark : "#000",
          colorLight : "#fff",
        })
      })
    },
    handleClick(){
    },
    //作品详情
    getData(){
      let params = {
        id: this.$route.query.id
      }
      this.api.getOpuses(params, true).then(res=>{
        if(res.error['err_code'] !== 0) return;
        if(res.obj.list.length <= 0){
          this.$message.info('该作品没有开放查看权限。');
          return;
        }
        this.params = res.obj.list[0] || {};
        //作品图片分割
        this.params.image_detailsPath = this.params.image_detailsPath ? this.params.image_detailsPath.split('|') : [];
        this.params.highlight_image_detailsPath = this.params.highlight_image_detailsPath ? this.params.highlight_image_detailsPath.split('|') : [];
        this.liked.liked_flag = this.params.isLike;
        this.counts.liked_counts = this.params.like_count;
        //查询作者其他作品
        this.getOtherOpus();
        //查询指导老师
        this.getTeacherStudents();
        //查询创作人员
        this.getDesigner();
        //查询浏览记录
        this.getMessages();
        //查询团队成员
        this.getDesignerCodes(this.params.team_member_list);
      })
    },
    //查询创作人员
    getDesigner(){
      let params = {
        user_id: this.params.user_id
      }
      this.api.getFrontDesigners(params).then(res=>{
        if(res.error['err_code'] !== 0) return;
        this.designer = res.obj.list[0] || {};
      })
    },
    //查询指导老师
    getTeacherStudents(){
      if(!this.params.student) return;
      let params = {
        student: this.params.student
      }
      this.api.getTeacherStudents(params).then(res=>{
        if(res.error['err_code'] !== 0) return;
        this.teacher = res.obj.list;
      })
    },
    //猜您喜欢
    getOtherOpus(){
      let params = {
        pageSize: 4,
        exhibition_category: this.params.exhibition_category
      }
      this.api.getOpusExhibitions(params).then(res=>{
        if(res.error['err_code'] !== 0) return;
        this.opus_list = res.obj.list;
      })
    },
    // 获取作品浏览记录
    getMessages() {
      this.api.getMessages({ code: this.params.code,type:'EntityTypeOpus' }).then(res => {
        console.log(res);
        if (res.error.err_code !== 0) return;
        let list = res.obj.list;
        this.record_list = list.length ? list : [];
      });
    },
    //查询团队成员
    getDesignerCodes(team_member_list){
      let codes = [];
      team_member_list.forEach(item=>{
        codes.push(item.code)
      })
      if(codes.length <= 0) return;
      let params = {
        codes: codes.join(',')
      }
      this.api.getFrontStudents(params).then(res=>{
        if(res.error['err_code'] !== 0) return;
        let list = res.obj.list;
        this.team_member_list = list;
      })
    },
    //到作品详情
    toOpusDetail(id){
      this.$router.replace({
        path: '/pro_detail',
        query:{
          id: id
        }
      })
      window.location.reload()
    },
    // 显示两个切换按钮
    showBtns(flag) {
      this.btns_flag = flag;
    },
    // 下一页按钮
    next() {
      if (this.j_flag) {
        this.j_flag = false;
        this.click_counts++;
        let opus_box = document.querySelectorAll(".opus_box")[0];
        let opus1 = opus_box.childNodes[0];
        let ml = opus1.style.marginLeft
          ? parseInt(opus1.style.marginLeft.replace("px", ""))
          : 0;
        opus1.style.marginLeft = `${ml - 294}px`;
        setTimeout(() => {
          this.j_flag = true;
        }, 600);
      }
    },
    // 上一页按钮
    pre() {
      if (this.j_flag) {
        this.j_flag = false;
        this.click_counts--;
        let opus_box = document.querySelectorAll(".opus_box")[0];
        let opus1 = opus_box.childNodes[0];
        let ml = opus1.style.marginLeft
          ? parseInt(opus1.style.marginLeft.replace("px", ""))
          : 0;
        opus1.style.marginLeft = `${ml + 294}px`;
        setTimeout(() => {
          this.j_flag = true;
        }, 600);
      }
    }
  }
};
</script>

<style lang="scss">
.pro_detail_page {
    padding-top: 20px;
  .m {
    .pro_detail {
      display: flex;
      position: relative;
      .pro_detail_l {
        width: 900px;
        .pro_info {
          padding: 13px 39px 24px;
          box-sizing: border-box;
          background: #fff;
          h3 {
            font-size: 24px;
            line-height: 60px;
            color: #333;
          }
          h4 {
            font-size: 14px;
            line-height: 24px;
            color: #999;
          }
          .pro_info_footer {
            margin-top: 28px;
            display: flex;
            justify-content: space-between;
            .pro_info_footer_l {
              font-size: 14px;
              color: #999;
            }
            .pro_info_footer_r {
              font-size: 12px;
              color: #aaa;
              display: flex;
              align-content: center;
              span{
                display: flex;
                align-items: center;
                i{
                  margin-right: 6px;
                }
              }
              span + span {
                margin-left: 20px;
              }
            }
          }
        }
        .pro_detail_text_img {
          background: #fff;
          margin-top: 10px;
          .el-tabs__active-bar{
            background: $color-default;
            height: 3px;
          }
          .el-tabs__item.is-active{
             color: $color-default;
          }
          .el-tabs{
            .el-tabs__header{
              padding: 0 20px;
            }
            .el-tabs__nav-scroll{
              height: 56px;
            }
            .el-tabs__nav{
              height: 56px;
              line-height: 56px;
            }
            .el-tabs__nav-wrap:after{
              height: 1px;
              background-color: #eeeeee;
            }
          }

          p.synopsis {
            font-size: 14px;
            line-height: 27px;
            color: #333;
            padding: 78px 41px 66px 71px;
            text-align: center;
            white-space: pre-line;
          }
          img.detail_img {
            width: 100%;
          }
          .record_box{
            padding: 20px;
            .record_item{
              display: flex;
              align-items: center;
              margin-bottom: 20px;
            }
            .record_item .avatar{
              width: 40px;
              height: 40px;
              border-radius: 50%;
              overflow: hidden;
              margin-right: 20px;
            }
            .record_item .avatar img{
              width: 100%;
              height: 100%;
            }
          }
        }
        .fun_box {
          height: 204px;
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
          .like {
            width: 80px;
            height: 80px;
            background: rgba(17, 17, 17, 1);
            border-radius: 50%;
            color: #fff;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            i {
              font-size: 21px;
            }
            span {
              font-size: 12px;
              margin-top: 10px;
            }
          }
          .islink{
            width: 80px;
            height: 80px;
            background: #d9d9d9;
            border-radius: 50%;
            color: #fff;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            i {
              font-size: 21px;
            }
            span {
              font-size: 12px;
              margin-top: 10px;
            }
          }
          .share {
            width: 88px;
            height: 34px;
            border: 1px solid rgba(204, 204, 204, 1);
            border-radius: 4px;
            display: flex;
            justify-content: center;
            align-items: center;
            position: absolute;
            right: 0px;
            top: 20px;
            cursor: pointer;
            div.share_btn{
              width: 100%;
              height: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
              & > i {
                font-size: 14px;
              }
              & > span {
                margin-left: 10px;
                font-size: 14px;
                color: #999999;
              }
            }

            .share_dialog {
              display: flex;
              justify-content: space-between;
              width: 433px;
              /*height: 170px;*/
              background: rgba(255, 255, 255, 1);
              box-shadow: 0px 0px 20px 0px rgba(187, 193, 203, 0.24);
              position: absolute;
              top: 44px;
              z-index: 1;
              padding: 29px 30px;
              box-sizing: border-box;
              .share_dialog_l {
                p {
                  font-size: 14px;
                  color: #333;
                  margin-bottom: 13px;
                }
                .el-input-group__append {
                  background: #111;
                }
                .fuzhi {
                  background: #111111;
                  color: #fff;
                }
              }
              .share_dialog_r {
                text-align: center;
                p {
                    font-size:14px;
                    color: #333;
                }
                >div {
                  width: 110px;
                  height: 110px;
                  margin-top: 10px;
                  img{
                    width: 100%;
                  }
                }
              }
            }
          }
        }
      }
      .pro_detail_r {
        background: #fff;
        width: 280px;
        position: absolute;
        right: 0;
        dl {
          dt {
            height: 55px;
            line-height: 55px;
            font-size: 16px;
            color: #333;
            text-indent: 20px;
            border-bottom: 1px solid #eee;
          }
          dd.author {
            display: flex;
            padding: 20px;
            .author_l {
              width: 60px;
              height: 60px;
              background: #f0f0f0;
              border-radius: 50%;
              overflow: hidden;
              img {
                width: 60px;
                height: 60px;
                object-fit: cover;
              }
            }
            .author_r {
              margin-left: 16px;
              flex: 1;
              display: flex;
              flex-direction: column;
              justify-content: space-around;
              .author_r_t {
                display: flex;
                justify-content: space-between;
                align-items: center;
                .author_name {
                  font-size: 14px;
                  color: #333;
                }
                .care_btn {
                  padding: 6px 11px 4px;
                  border: 1px solid rgba(221, 221, 221, 1);
                  border-radius: 13px;
                  color: #333;
                  cursor: pointer;
                }
                .care_btn2 {
                  padding: 6px 16px 4px;
                  border: 1px solid #111;
                  background: #111;
                  border-radius: 13px;
                  color: #fff;
                  cursor: pointer;
                }
              }
              .author_r_b {
                font-size: 12px;
                color: #999;
              }
            }
          }
        }
      }
    }
  }
  .designer_other_opus {
    width: 100%;
    height: 377px;
    background: rgba(255, 255, 255, 1);
    .other_opus_inner {
      .tit {
        padding-left: 8px;
        position: relative;
        h1 {
          font-size: 30px;
          font-weight: 600;
          color: #111;
          line-height: 110px;
        }
      }
      .tit::before {
        content: "";
        display: block;
        width: 30px;
        height: 30px;
        position: absolute;
        background: rgba(91, 134, 231, 1);
        opacity: 0.4;
        left: 0;
        top: 30px;
      }
      .other_opus {
        .other_opus_box {
          .other_opus_content {
            position: relative;
            .opus_box {
              width: 1160px;
              overflow: hidden;
              white-space: nowrap;
              .opus_item {
                width: 274px;
                height: 199px;
                margin-right: 20px;
                display: inline-block;
                transition: all 0.5s;
                cursor: pointer;
                user-select: none;
                img {
                  width: 100%;
                  height: 199px;
                  object-fit: cover;
                }
              }
            }
            .next,
            .pre {
              width: 46px;
              line-height: 46px;
              text-align: center;
              font-size: 20px;
              color: rgba(51, 51, 51, 0.7);
              border-radius: 50%;
              position: absolute;
              top: 70px;
              background: rgba(255, 255, 255, 1);
              box-shadow: 0px 0px 22px 0px rgba(163, 170, 182, 0.5);
              cursor: pointer;
              transition: all 0.3s;
              opacity: 0;
            }
            .showbtns {
              opacity: 1;
            }
            .next {
              right: 15px;
            }
            .pre {
              left: -23px;
            }
          }
        }
      }
    }
  }
}
</style>
